import {
	ASK_LOCATION_PERMISSION_SUCCESS,
	LOAD_LOCATION_PERMISSION_STATUS_SUCCESS,
} from 'new-constants/permission.constants';
import {NativePermissionStatuses} from 'new-constants/common.constants';
import {PermissionState} from './permission.reducer.types';

const initialState: PermissionState = {
	location: {
		status: null,
		isGranted: false,
		isRequested: false,
	},
};

export const permissionReducer = (previousState = initialState, action): PermissionState => {
	switch (action && action.type) {
		case ASK_LOCATION_PERMISSION_SUCCESS:
		case LOAD_LOCATION_PERMISSION_STATUS_SUCCESS:
			return {
				...previousState,
				location: {
					...previousState.location,
					status: action.status,
					isGranted:
						action.status === NativePermissionStatuses.GRANTED ||
						action.status === NativePermissionStatuses.GRANTED_WHEN_IN_USE,
					isRequested: action.status !== NativePermissionStatuses.NOT_REQUESTED,
				},
			};
			break;
		default:
			return previousState;
	}
};
